// extracted by mini-css-extract-plugin
export default {"metamaskText":"info_metamaskText__r8seV","goerliText":"info_goerliText__15Wuu","contractText":"info_contractText__emk5y","infoheading":"info_infoheading__PkO+v"};